import { BasicClient } from '@/utils/httpClient';

export default class Actions {
    client;
    constructor() {
        this.client = new BasicClient();
    }
    checkNotificationActive() {
        return this.client.exec('/v2/notification-release', 'GET');
    }
}